module.exports = __webpack_public_path__ + "img/jersey_thumbnail_mobile.d553d09e.jpg";